module.exports = __webpack_public_path__ + "img/ic_order_wait_bus.4d5daed5.png";